
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsTemplatesGrid extends Serenity.EntityGrid<SmsTemplatesRow, any> {
        protected getColumnsKey() { return SmsTemplatesColumns.columnsKey; }
        protected getDialogType() { return SmsTemplatesDialog; }
        protected getIdProperty() { return SmsTemplatesRow.idProperty; }
        protected getInsertPermission() { return SmsTemplatesRow.insertPermission; }
        protected getLocalTextPrefix() { return SmsTemplatesRow.localTextPrefix; }
        protected getService() { return SmsTemplatesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}